import React from "react";
import "./GenrePreview.css";

// Tiny auto-looping CSS gameplay preview per genre. `kind` selects the mini-scene.
const SCENES = {
  fighting: (
    <div className="gp gp-fight">
      <i className="hp hp1" /><i className="hp hp2" />
      <span className="f f1">🥋</span><span className="f f2">🥊</span>
      <span className="hit">💥</span>
    </div>
  ),
  battle: (
    <div className="gp gp-battle">
      <i className="ring" />
      <span className="para emo">🪂</span>
      <span className="dot d1" /><span className="dot d2" />
    </div>
  ),
  sandbox: (
    <div className="gp gp-sandbox">
      <span className="hero">🧍</span>
      <i className="blk b1" /><i className="blk b2" /><i className="blk b3" /><i className="blk b4" />
    </div>
  ),
  horror: (
    <div className="gp gp-horror">
      <i className="torch" />
      <span className="ghost">👻</span>
    </div>
  ),
  soccer: (
    <div className="gp gp-soccer">
      <span className="score">1 : 0</span>
      <span className="goal">🥅</span>
      <span className="ball">⚽</span>
    </div>
  ),
  visualnovel: (
    <div className="gp gp-vn">
      <span className="portrait">🧝</span>
      <div className="box"><span className="type">Choose your path, traveler…</span></div>
    </div>
  ),
  rhythm: (
    <div className="gp gp-rhythm">
      <i className="note n1" /><i className="note n2" /><i className="note n3" /><i className="note n4" />
      <i className="line" />
    </div>
  ),
  platformer: (
    <div className="gp gp-plat">
      <span className="coin">🪙</span>
      <span className="hero">🍄</span>
      <i className="ground" />
    </div>
  ),
  shooter: (
    <div className="gp gp-shoot">
      <span className="tgt t1">🎯</span><span className="tgt t2">🎯</span>
      <i className="cross" />
    </div>
  ),
  openworld: (
    <div className="gp gp-open">
      <span className="sun">☀️</span>
      <i className="hill h1" /><i className="hill h2" />
      <span className="walker">🚶</span>
    </div>
  ),
  racing: (
    <div className="gp gp-race">
      <i className="speed s1" /><i className="speed s2" />
      <span className="kart">🏎️</span>
      <span className="flag">🏁</span>
    </div>
  ),
  tower: (
    <div className="gp gp-tower">
      <i className="path" />
      <span className="tow">🗼</span>
      <i className="shot" />
      <span className="enemy">👾</span>
    </div>
  ),
};

export function GenrePreview({ kind }) {
  return SCENES[kind] || null;
}
